import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { SetCloseResult, SetIsEditing, SetIsEditingModalOpen } from './editing.actions';
import { patch } from '@ngxs/store/operators';

export type EditingStateModel = {
  isEditing: boolean;
  isEditingModalOpen: boolean;
  closeResult: boolean|null;
};

export const initialState: EditingStateModel = {
  isEditing: false,
  isEditingModalOpen: false, // TODO: This would be necessary to open the modal when implemented.
  closeResult: null,
};

@State<EditingStateModel>({
  name: 'editing',
  defaults: initialState,
})
@Injectable()
export class EditingState {
  @Selector()
  static isEditing(state: EditingStateModel) {
    return state.isEditing;
  }

  @Selector()
  static isEditingModalOpen(state: EditingStateModel) {
    return state.isEditingModalOpen;
  }

  @Selector()
  static closeResult(state: EditingStateModel) {
    return state.closeResult;
  }

  @Action(SetIsEditing)
  setIsEditing(context: StateContext<EditingStateModel>, { isEditing }: SetIsEditing) {
    context.setState(patch({ isEditing }));
  }

  @Action(SetIsEditingModalOpen)
  setIsEditingModalOpen(context: StateContext<EditingStateModel>, { isEditingModalOpen }: SetIsEditingModalOpen) {
    context.setState(patch({ isEditingModalOpen }));
  }

  @Action(SetCloseResult)
  setCloseResult(context: StateContext<EditingStateModel>, { closeResult }: SetCloseResult) {
    context.setState(patch({ closeResult }));
  }
}
